/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:18/06/2022
 @Time:14:06
 **/
import Client from "./Client";
export default  class PersonneClient extends Client
{

    /**
     * create un objet SocieteClient
     * @param {{}} clientJson
     * @param {Client}clientBase
     * @return PersonneClient
     */
    static createObjectFromJson(clientJson,clientBase)
    {
        let client=new PersonneClient();
        super.createObjectFromJson(clientJson,client)
        return client;
    }

}